var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportFriendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6447_27630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00016 3.35999C8.50016 3.35999 8.09016 3.76999 8.09016 4.26999L8.27016 11.01C8.27016 11.41 8.60016 11.74 9.00016 11.74C9.40016 11.74 9.73016 11.41 9.73016 11.01L9.91016 4.26999C9.91016 3.76999 9.50016 3.35999 9.00016 3.35999ZM9.00016 12.46C8.40016 12.46 7.91016 12.95 7.91016 13.55C7.91016 14.15 8.40016 14.64 9.00016 14.64C9.60016 14.64 10.0902 14.15 10.0902 13.55C10.0902 12.95 9.60016 12.46 9.00016 12.46Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3283 18H6.66828C5.76828 18 4.91828 17.65 4.27828 17.01L0.978281 13.71C0.338281 13.07 -0.0117188 12.22 -0.0117188 11.32V6.66C-0.0117188 5.76 0.338281 4.91 0.978281 4.27L4.27828 0.99C4.91828 0.35 5.76828 0 6.66828 0H11.3283C12.2183 0 13.0883 0.36 13.7183 0.99L17.0183 4.29C17.6483 4.92 18.0083 5.79 18.0083 6.68V11.34C18.0083 12.24 17.6583 13.09 17.0183 13.73L13.7183 17.03C13.0783 17.67 12.2383 18.02 11.3283 18.02V18ZM6.66828 1.12C6.06828 1.12 5.49828 1.35 5.07828 1.78L1.77828 5.07C1.35828 5.49 1.11828 6.06 1.11828 6.66V11.32C1.11828 11.92 1.34828 12.49 1.77828 12.91L5.06828 16.21C5.49828 16.63 6.05828 16.87 6.65828 16.87H11.3183C11.9183 16.87 12.4883 16.64 12.9083 16.21L16.2083 12.91C16.6283 12.48 16.8683 11.92 16.8683 11.32V6.66C16.8683 6.07 16.6283 5.49 16.2083 5.07L12.9083 1.77C12.4883 1.35 11.9083 1.11 11.3183 1.11H6.65828L6.66828 1.12Z",
    fill: "#616161"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6447_27630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportFriendIcon);
export default __webpack_public_path__ + "static/media/reportFriendIcon.329799a6fcd94215b1ceefa8f0131c2c.svg";
export { ForwardRef as ReactComponent };